<template>
  <v-layout row>
    <v-layout
      align-end
      class="my-2"
    >
      <v-flex xs4>
        <app-reference
          v-model="unloadingCountry"
          :outline="true"
          class="mx-2 my-0"
          label="Страна прибытия"
          :height-field="44"
          resource="countries"
          component-name="Country"
          @input="unloadingCountryChange"
        />
      </v-flex>
      <v-flex xs4>
        <app-reference
          v-model="unloadingWarehouse"
          :outline="true"
          class="mx-2 my-0"
          label="Склад"
          resource="warehouses"
          component-name="Warehouse"
          parent-filter="countryId"
          :parent-id="unloadingCountry ? unloadingCountry.id : 0"
          filter-name="groupedWarehouse"
          :filter-value="unloadingWarehouseFilter"
          :without-parent-lock="true"
          :height-field="44"
          @input="entityChange"
        />
      </v-flex>
      <v-flex xs4>
        <warehouse-loading-address
          v-model="unloadingAddress"
          label="Адрес места прибытия"
          :warehouse-id="unloadingWarehouse ? unloadingWarehouse.id : 0"
          @input="entityChange"
        />
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import WarehouseLoadingAddress from "./WarehouseLoadingAddress.vue";

export default {
  components: {
    WarehouseLoadingAddress,
  },
  props: ["entity", "warehouseMode"],
  data() {
    return {
      unloadingCountry: null,
      unloadingWarehouse: null,
      unloadingAddress: null,
    };
  },
  computed: {
    unloadingWarehouseFilter() {
      return this.warehouseMode === "groupedWarehouse" ? true : false;
    },
  },
  watch: {
    unloadingAddress() {
      this.unloadingCountry = this.entity.unloadingCountry
        ? this.entity.unloadingCountry
        : this.entity.unloadingAddress && this.entity.unloadingAddress.country
          ? {
            id: this.entity.unloadingAddress.country.id,
            title: this.entity.unloadingAddress.country.title,
          }
          : null;
      this.entityChange();
    },
    entity: {
      handler(value) {
        this.unloadingCountry = value ? value.unloadingCountry : null;
        this.unloadingWarehouse = value ? value.unloadingWarehouse : null;
        this.unloadingAddress = value ? value.unloadingAddress : null;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    entityChange() {
      this.$emit("change", {
        unloadingCountry: this.unloadingCountry,
        unloadingWarehouse: this.unloadingWarehouse,
        unloadingAddress: this.unloadingAddress,
      });
    },
    unloadingCountryChange() {
      this.unloadingWarehouse = null;
      this.unloadingAddress = null;
      this.entityChange();
    },
  },
};
</script>
